export default __webpack_public_path__ + "15934d5482a9c6420e03b73e83062352.png";